/**
 * Détecte si l'app tourne dans un wrapper natif Capacitor (iOS / Android)
 * ou dans un navigateur web classique.
 *
 * Capacitor injecte `window.Capacitor` au runtime dans les wrappers natifs.
 * Sur le web, cet objet n'existe pas → on retourne false sans avoir besoin
 * d'importer @capacitor/core (aucune dépendance ajoutée au build web).
 *
 * Usage :
 *   import { isNativePlatform, getPlatform } from "../lib/platform";
 *   if (isNativePlatform()) { ... }
 */

export function isNativePlatform() {
  if (typeof window === "undefined") return false;
  const cap = window.Capacitor;
  if (!cap) return false;
  // Capacitor v3+ expose isNativePlatform(). Fallback sur le platform check.
  if (typeof cap.isNativePlatform === "function") return cap.isNativePlatform();
  const platform = (cap.getPlatform && cap.getPlatform()) || cap.platform;
  return platform === "ios" || platform === "android";
}

export function getPlatform() {
  if (typeof window === "undefined") return "web";
  const cap = window.Capacitor;
  if (!cap) return "web";
  if (typeof cap.getPlatform === "function") return cap.getPlatform();
  return cap.platform || "web";
}

export function isIOS() {
  return getPlatform() === "ios";
}

export function isAndroid() {
  return getPlatform() === "android";
}
